export enum MessageSenderType {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}
